import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { AppData } from "src/app/helpers/app-data";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { BaseServiceService } from "src/app/services/base-service.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import {
  fluentTooltip,
  provideFluentDesignSystem,
} from "@fluentui/web-components";
import {DomSanitizer} from '@angular/platform-browser';
import { lastValueFrom } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from "moment";

declare var fabric: any;

@Component({
  selector: "app-datatable-historial",
  templateUrl: "./datatable-historial.component.html",
  styleUrl: "./datatable-historial.component.css",
})
export class DatatableHistorialComponent implements OnInit {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  dtTrigger: Subject<any> = new Subject<any>();
  dialogComponentVerProcesos: any;
  dialogComponentDescargarReporte: any;
  reportForm: FormGroup;
  idEjecucionProceso: number;
  NombreProceso: string;
  getDataTableHistorial: any = [
    "HisitoriaProcesoEjecucion",
    "GetDataTableHistoriaProcesoEjecucion",
  ];

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];

  dtOptionsDetalleEjecucionProceso: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 5,
    serverSide: true,
    processing: true,
    searching: true,
    ordering: true,
    columnDefs: [
      {
        targets: 12,
        className: 'datos-ejecucion-column'
      }
    ],
    scrollX: true,
    language: {
      url: "../../../assets/es-ES.json",
    },
    lengthMenu: [5], // Ocultar la opción de cambiar la cantidad de registros a mostrar
  };

  getDataTableDetalleEjecucionProceso: string =
    "HisitoriaProcesoEjecucion/DetalleHistoriaProcesoEjecucion?IdEjecucion=";

  columnas = [
    { title: "ID", data: "Id", order: 'desc' }, // Esta columna se ordenará en descendente
    { title: "Nombre Proceso", data: "NombreProceso" },
    { title: "Versión Proceso", data: "VersionProceso" },
    { title: "Estado Proceso", data: "EstadoProceso" },
    { title: "Usuario Creacion", data: "UsuarioInicia" },
    { title: "Fecha Inicia", data: "FechaInicia" },
    { title: "Fecha Finaliza", data: "FechaFinaliza" },
    { title: "Tiempo de Ejecucion", data: "TiempoEjecucion" }
  ];

  IdProcessDetail: string = "";
  IsCancelProcess: boolean = false;
  dialogComponentEnviarAccionProceso: any;
  dialogComponentCancelarProceso: any;
  cancelProcessForm: FormGroup;
  viewObs: boolean = false;

  /* Datatable */

  constructor(
    private http: HttpClient,
    private baseService: BaseServiceService,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private _formBuilder:FormBuilder
  ) {}

  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push(
      { "button-id": "btnVerProceso", "button-icon": "ms-Icon--TaskManager","button-tooltip": "Ver Proceso"  ,'conditional-data': [
      { key: 'field', value: 'NombreProceso' }
    ]},
    { "button-id": "btnDescargarExcel", "button-icon": "ms-Icon--ExcelDocument","button-tooltip": "Descargar Reporte"}
    );

    this.cancelProcessForm = this._formBuilder.group({
      Observacion: new FormControl('', [Validators.required, Validators.maxLength(1000)])
    });

    this.reportForm = this._formBuilder.group({
      fechaInicio: new FormControl(moment(), [Validators.required]),
      fechaFin: new FormControl(moment(), [Validators.required]),
    });

    var DropdownHTMLElements = document.querySelectorAll(".ms-Dropdown");
    for (var i = 0; i < DropdownHTMLElements.length; ++i) {
      var Dropdown = new fabric["Dropdown"](DropdownHTMLElements[i]);
    }

    var DatePickerElements = document.querySelectorAll(".ms-DatePicker-holder");
    for (var i = 0; i < DatePickerElements.length; i++) {
      new fabric["DatePicker"](DatePickerElements[i]);
    }

    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }
  }

  ngAfterViewInit(): void {
    // 
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.on("draw", () => {
    //     this.attachClickEvents();
    //   });
    // });
  }

  ngOnDestroy(): void {
    // Destroy the DataTables when the component is destroyed to prevent memory leaks
   /*  if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.off("draw");
      });
    } */
  }

  attachClickEvents(): void {

    const obsButtons = document.querySelectorAll("#ObservacionesTarea");

    obsButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        this.cancelProcessForm.controls['Observacion'].setValue(button.getAttribute("data-id"));
        this.viewObs = true;

        const dialogSendActionProcess = document.querySelector(".cancel-observation");
        this.dialogComponentCancelarProceso = new fabric["Dialog"](dialogSendActionProcess);
        this.dialogComponentCancelarProceso.open();
      });
    });
  }

  clearCancelForm()
  {
    this.cancelProcessForm.reset();
  }

  closeCancelModal()
  {
    this.cancelProcessForm.reset();
    this.dialogComponentCancelarProceso.close();
  }

  async enviarAccionProceso()
  {

    const response = await lastValueFrom(this.http.post<any>(AppData.API_URL+"EjecucionProceso/AccionProceso?IdEjecucionDetalle="+this.IdProcessDetail+"&IsCancel="+this.IsCancelProcess+'&Observacion='+(this.IsCancelProcess ? this.cancelProcessForm.get('Observacion').value : null), null));

    if (!response.Ok) {

      let mensajeError = "<ul>";
      response.ValidationErrors.forEach((error: any) => {
        mensajeError += `<li>${error}</li>`;
      });
      mensajeError += "</ul>";

      this.baseService.triggerShowModal(
        this.IsCancelProcess ? "Error al cacelar proceso" : "Error al reiniciar proceso",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      
    } else {

      if(this.IsCancelProcess)
      {
        this.dialogComponentCancelarProceso.close();
      }
      else
      {
        this.dialogComponentEnviarAccionProceso.close();
      }

      this.baseService.triggerShowModal(
        this.IsCancelProcess ? "Proceso cacelado" : "Proceso retomado",
        this.IsCancelProcess ? "Proceso cacelado exitosamente" : "Proceso retomado exitosamente",
        ModalNotifyTypes.Success,
        false
      );

      this.abrirModalTareasEjecucionProcesos();
      this.reloadDataTable();
      
    }

  }

  async edit(userId: number) {
    try {
      await this.baseService.setIdSeleccionado(userId);
      this.baseService.abrirModalEditar();
    } catch (error) {
      console.error("Error al establecer el ID:", error);
    }
  }

  async delete(userId: number) {
    try {
      // Llamamos a triggerShowModal para abrir el modal de confirmación
      this.baseService.triggerShowModal(
        "Eliminar Grupo",
        "¿Seguro que desea eliminar el Grupo?",
        ModalNotifyTypes.Warning,
        true
      );

      this.modalNotifyComponent.actionConfirmed.subscribe(
        (confirmed: boolean) => {
          if (confirmed) {
            this.baseService
              .delete("GrupoUsuario/BorrarGrupo", userId)
              .then(() => {
                this.reloadDataTable();
                this.baseService.triggerShowModal(
                  "Grupo Eliminado",
                  "Grupo Eliminado Correctamente",
                  ModalNotifyTypes.Success,
                  false
                );
              });
          } else {
          }
        }
      );
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error al enviar el formulario:",
        error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  reloadDataTable(): void {
    this.dtInstance.ajax.reload(null,false);
  }

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any) {
    try {
      
      this.idEjecucionProceso = event["data-id"];
      this.NombreProceso = event["data-field"];

      switch (event["button-id"]) {
        case "btnVerProceso":
          this.abrirModalTareasEjecucionProcesos();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.on("draw", () => {
              this.attachClickEvents(); 
            });
          });
          break;
        case "btnDescargarExcel":
          this.baseService.descargarReporte(this.idEjecucionProceso, "HisitoriaProcesoEjecucion", "GenerarExcelHistoriaProceso", "ReporteHistorialProcesos");
          break;
       
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  // Función recursiva para mapear y organizar el contenido del tooltip
  mapObjectToHtml(obj: any, indent: number = 0): string {
    if (obj === null || obj === undefined || obj === '') {
      return `<div class="tooltip-content" style="margin-left: ${
        indent * 10
      }px;"><strong>Valor:</strong> null</div>`;
    }

    let html = "";
    const indentStyle = `style="margin-left: ${indent * 10}px;"`;

    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === "object" && value !== null) {
        html += `<div ${indentStyle}><strong>${key}:</strong></div>`;
        html += this.mapObjectToHtml(value, indent + 1);
      } else {
        const sanitizedValue = value !== null && value !== undefined ? this.sanitizer.sanitize(1, value.toString()) : 'N/A';
        html += `<div ${indentStyle}><strong>${key}:</strong> ${ sanitizedValue } </div>`;
      }
    }
    

    return html;
  }

  clearReportForm()
  {
    this.reportForm.reset();
  }

  openReportModal()
  {
    const dialogDownloadReport = document.querySelector(".download-report");
    this.dialogComponentDescargarReporte = new fabric["Dialog"](dialogDownloadReport);
    this.dialogComponentDescargarReporte.open();
  }

  async descargarReporteGeneral() {
    try {

      let fechaInicio = this.reportForm.get('fechaInicio').value.format('MM-DD-YYYY');
      let fechaFin = this.reportForm.get('fechaFin').value.format('MM-DD-YYYY');
      const response = await lastValueFrom(
        this.http.get(
          AppData.API_URL +
            `HisitoriaProcesoEjecucion/GenerarReporte?FechaInicio=${fechaInicio}&FechaFin=${fechaFin}`,
          { responseType: "blob" }
        )
      );
      const url = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = url;
      a.download = 'ReporteGeneralHistorico.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.reportForm.reset();
      this.dialogComponentDescargarReporte.close();
    } catch (error) {
      console.error("Error descargando el documento", error);
    }
  }

  abrirModalTareasEjecucionProcesos() {

    $('#processId').html('Proceso ' + this.idEjecucionProceso + ' - ' + this.NombreProceso);

    if ($.fn.dataTable.isDataTable($("#datatableDetalleEjecucionProcesos"))) {
      $("#datatableDetalleEjecucionProcesos").DataTable().clear().destroy();
    }
    // const dialog = document.querySelector(".ver-procesos");
    // this.dialogComponentVerProcesos = new fabric["Dialog"](dialog);
    // this.dialogComponentVerProcesos.open();
    // let tooltipText;

    this.dtOptionsDetalleEjecucionProceso.ajax = async (
      dataTablesParameters: any,
      callback
    ) => {
      this.http
        .post<any>(
          AppData.API_URL + this.getDataTableDetalleEjecucionProceso + this.idEjecucionProceso,
          dataTablesParameters
        )
        .subscribe((resp) => {
          
          callback({
            draw: resp.Data.draw,
            recordsTotal: resp.Data.recordsTotal,
            recordsFiltered: resp.Data.recordsFiltered,
            data: resp.Data.data,
          });
        });
    };
    provideFluentDesignSystem().register(fluentTooltip());

    this.dtOptionsDetalleEjecucionProceso.columns = [
      { title: "Id", data: "Id" },
      { title: "Nombre Elemento", data: "NombreElemento" },
      { title: "Documentación", data: "Documentacion" },
      { title: "Tipo Elemento", data: "TipoElemento" },
      { title: "Fecha Inicia", data: "FechaInicia" },
      { title: "Fecha Finaliza", data: "FechaFinaliza" },
      { title: "Fecha Expiracion", data: "FechaExpiraTarea", defaultContent: "Sin vencimiento", render: (d: any) => d ?? "Sin vencimiento" },
      { title: "Tiempo de Ejecucion", data: "TiempoEjecucion" },
      { title: "Estado Ejecución", data: "EstadoEjecucion" },
      { title: "Usuario Inicia", data: "UsuarioInicia" },
      { title: "Usuario Finaliza", data: "UsuarioFinaliza" },
      { title: "Desviacion", data: "Desviacion" },

      {
        title: "Datos Ejecución",
        data: "Id",
        orderable: false,
        render: (data: any, type: any, full: any, row: any) => {

          if(full.DataEjecucion != null)
          {
            let datosejecucion = JSON.parse(full.DataEjecucion);
            return type === 'display'? '<div style="height: 5em; line-height: 1em; overflow-x: hidden; overflow-y: scroll; width: 100%; font-size: larger; word-wrap: break-word;">' + this.mapObjectToHtml(datosejecucion) +'</div>' : '';
          }
          else
          {
            return '';
          }
          

          
                    // Mapear las claves y valores del objeto a una cadena de texto organizada
                  //   let tooltipContent = this.mapObjectToHtml(datosejecucion);

                  //   return `
                  //      <div>
                  //       <button class="ms-CommandButton-button" type="button" id="btnTask-${full.Id}" data-id="${full.Id}">
                  //         <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--View"></i></span>
                  //       </button>
                        
                  //       <fluent-tooltip anchor="btnTask-${full.Id}">
                  //         <div class="tooltip-content">
                  //           ${tooltipContent}
                  //         </div>
                  //       </fluent-tooltip>
                  //     </div>
          
                  // `;
        },
      },
      {
        title: "Opciones",
        data: "Id",
        orderable: false,
        render: (data: any, type: any, full: any, row: any) => {
          
          if(full.EstadoEjecucion == "Cancelado")
          {

            return type === 'display' ? `<button class="ms-CommandButton-button opt-button" data-id="${full.Observacion}" id="ObservacionesTarea">
            <span title="Observación Cancelación" class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Comment"></i></span>
            </button>` : '';   

          }
          else
          {
            return '';
          }
        },
      },
    ];

    this.dtTrigger.next(null);
  }
}
